import React from "react";
import InputMask from "../../../components/InputMask/index.js";

/**
 * Seção de informações e formulário de Filial para o TCE.
 *
 * @param {object} props
 * @param {boolean} props.mostrarFiliais - Indica se a filial pode ser exibida
 * @param {object} props.formData - Objeto do formulário
 * @param {string} props.localAtividade - Filial selecionada
 * @param {Function} props.setLocalAtividade - Callback para alterar a filial selecionada
 * @param {Array} props.filiais - Lista de filiais disponíveis
 * @param {boolean} props.filialLoading - Se os dados da filial estão sendo carregados
 * @param {boolean} props.isEmpresaReadOnly - Flag de somente leitura
 * @param {boolean} props.isEmpresaDisabled - Flag de desabilitado
 * @param {Function} props.handleChange - Handler padrão de alteração dos inputs
 */
export const TceFilialSection = ({
  mostrarFiliais,
  formData = {},
  localAtividade = "",
  setLocalAtividade,
  filiais = [],
  filialLoading = false,
  isEmpresaReadOnly = false,
  isEmpresaDisabled = false,
  handleChange,
}) => {
  if (!mostrarFiliais || formData.local_realizacao_atividades !== "FILIAL") {
    return null;
  }

  return (
    <>
      <div id="tce-section-filial" />
      <hr className="tce-hr" style={{ margin: "1.5rem 0" }} />

      <div style={{ marginBottom: "1rem" }}>
        <label
          className="all-label"
          style={{ fontSize: "1.1rem", fontWeight: "bold" }}
        >
          Informações da Filial
        </label>
      </div>

      <div className="tca-col-md-12 tca-mb-3">
        <label>Selecione a Filial Específica</label>
        <select
          className="tca-form-control"
          value={localAtividade}
          disabled={isEmpresaDisabled}
          onChange={(e) => {
            const val = e.target.value;
            setLocalAtividade(val);
          }}
        >
          <option value="">Selecione a filial</option>
          {filiais
            .filter(
              (f) =>
                f.id !== 0 &&
                f.id !== undefined &&
                f.id !== null,
            )
            .map((f) => (
              <option key={f.id} value={f.id}>
                {f.nome_filial ||
                  f.razao_social ||
                  f.nome ||
                  `Filial (ID: ${f.id})`}
              </option>
            ))}
        </select>
        {filialLoading && (
          <span
            style={{
              color: "#3b82f6",
              fontSize: "0.85rem",
              marginTop: "4px",
              display: "inline-block",
            }}
          >
            Carregando dados da filial...
          </span>
        )}
      </div>

      <div className="tce-two">
        <div className="tce-card-body">
          <div className="tca-row">
            <div className="tca-col-md-4 tca-mb-3">
              <label>Nome da Filial</label>
              <input
                className="tca-form-control"
                name="nome_filial"
                value={formData.nome_filial || ""}
                readOnly={isEmpresaReadOnly}
                disabled={isEmpresaDisabled}
                onChange={handleChange}
              />
            </div>

            <div className="tca-col-md-4 tca-mb-3">
              <label>CPF/CNPJ</label>
              <input
                type="text"
                className="tca-form-control"
                name="cpfCnpj"
                value={formData.cpfCnpj || ""}
                readOnly={isEmpresaReadOnly}
                disabled={isEmpresaDisabled}
                onChange={handleChange}
              />
            </div>

            <div className="tca-col-md-4 tca-mb-3">
              <label>CEP</label>
              <input
                type="text"
                className="tca-form-control"
                name="cepFilial"
                value={formData.cepFilial || ""}
                readOnly={isEmpresaReadOnly}
                disabled={isEmpresaDisabled}
                onChange={handleChange}
                maxLength={9}
                placeholder="Apenas números"
              />
            </div>

            <div className="tca-col-md-4 tca-mb-3">
              <label>Endereço</label>
              <input
                type="text"
                className="tca-form-control"
                name="enderecoFilial"
                value={formData.enderecoFilial || ""}
                readOnly={isEmpresaReadOnly}
                disabled={isEmpresaDisabled}
                onChange={handleChange}
              />
            </div>

            <div className="tca-col-md-4 tca-mb-3">
              <label>Bairro/Distrito</label>
              <input
                type="text"
                className="tca-form-control"
                name="bairro"
                value={formData.bairro || ""}
                readOnly={isEmpresaReadOnly}
                disabled={isEmpresaDisabled}
                onChange={handleChange}
              />
            </div>

            <div className="tca-col-md-4 tca-mb-3">
              <label>Municipio</label>
              <input
                type="text"
                className="tca-form-control"
                name="municipio"
                value={formData.municipio || ""}
                readOnly={isEmpresaReadOnly}
                disabled={isEmpresaDisabled}
                onChange={handleChange}
              />
            </div>

            <div className="tca-col-md-4 tca-mb-3">
              <label>UF</label>
              <input
                type="text"
                className="tca-form-control"
                name="uf"
                value={formData.uf || ""}
                readOnly={isEmpresaReadOnly}
                disabled={isEmpresaDisabled}
                onChange={handleChange}
              />
            </div>

            <div className="tca-col-md-4 tca-mb-3">
              <label>Telefone 1</label>
              <InputMask
                mask="(99)99999-9999"
                maskChar=" "
                className="tca-form-control"
                name="telefones"
                value={formData.telefones || ""}
                readOnly={isEmpresaReadOnly}
                disabled={isEmpresaDisabled}
                onChange={handleChange}
              />
            </div>

            <div className="tca-col-md-4 tca-mb-3">
              <label>Telefone 2</label>
              <InputMask
                mask="(99)99999-9999"
                maskChar=" "
                className="tca-form-control"
                name="telefones2"
                value={formData.telefones2 || ""}
                readOnly={isEmpresaReadOnly}
                disabled={isEmpresaDisabled}
                onChange={handleChange}
              />
            </div>

            <div className="tca-col-md-4 tca-mb-3">
              <label>E-mail Contrato</label>
              <input
                type="email"
                className="tca-form-control"
                name="emailContratos"
                value={formData.emailContratos || ""}
                readOnly={isEmpresaReadOnly}
                disabled={isEmpresaDisabled}
                onChange={handleChange}
              />
            </div>

            <div className="tca-col-md-4 tca-mb-3">
              <label>E-mail Financeiro</label>
              <input
                type="email"
                className="tca-form-control"
                name="emailFinanceiro"
                value={formData.emailFinanceiro || ""}
                onChange={handleChange}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="tce-card" style={{ marginTop: "15px" }}>
        <div className="div-dados-empresa-title tce-card-header">
          <label>Representante da Filial</label>
        </div>
        <div className="tce-card-body">
          <div className="tca-row">
            <div className="tca-col-md-4 tca-mb-3">
              <label>Representante Por</label>
              <input
                type="text"
                className="tca-form-control"
                name="representadaPor"
                value={formData.representadaPor || ""}
                onChange={handleChange}
              />
            </div>

            <div className="tca-col-md-4 tca-mb-3">
              <label>Cargo</label>
              <input
                type="text"
                className="tca-form-control"
                name="cargoRepresentante"
                value={formData.cargoRepresentante || ""}
                onChange={handleChange}
              />
            </div>

            <div className="tca-col-md-4 tca-mb-3">
              <label>E-mail</label>
              <input
                type="email"
                className="tca-form-control"
                name="emailRepresentante"
                value={formData.emailRepresentante || ""}
                onChange={handleChange}
              />
            </div>

            <div className="tca-col-md-4 tca-mb-3">
              <label>Responsável/Supervisor do Estágio</label>
              <input
                type="text"
                className="tca-form-control"
                name="responsavelSupervisor"
                value={formData.responsavelSupervisor || ""}
                onChange={handleChange}
              />
            </div>

            <div className="tca-col-md-4 tca-mb-3">
              <label>Cargo</label>
              <input
                type="text"
                className="tca-form-control"
                name="cargoSupervisor"
                value={formData.cargoSupervisor || ""}
                onChange={handleChange}
              />
            </div>

            <div className="tca-col-md-4 tca-mb-3">
              <label>E-mail</label>
              <input
                type="email"
                className="tca-form-control"
                name="emailSupervisor"
                value={formData.emailSupervisor || ""}
                onChange={handleChange}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TceFilialSection;
